import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const EXCLUDED_PATHS = ['/auth', '/reset-password', '/accept-invite'];

const ScrollToTop = () => {
  const { pathname, search } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });

    // Track previous non-auth path so "Back" buttons can return to the
    // last meaningful page (e.g. after login redirects).
    try {
      const isExcluded = EXCLUDED_PATHS.some((p) => pathname.startsWith(p));
      if (!isExcluded) {
        const current = sessionStorage.getItem('currentPath');
        if (current && current !== pathname + search) {
          sessionStorage.setItem('previousPath', current);
        }
        sessionStorage.setItem('currentPath', pathname + search);
      }
    } catch {
      // ignore storage errors
    }
  }, [pathname, search]);

  return null;
};

export default ScrollToTop;
